<template>
  <div class="layout">
    <console-header class="header"/>

    <div class="d-flex">
      <console-sidebar class="sidebar" />
      <console-content class="body" />
    </div>

    <loading
      class="loading"
      ref="loading"
    />
  </div>
</template>

<script>
import ConsoleHeader from './Header.vue'
import ConsoleSidebar from './Sidebar.vue'
import ConsoleContent from './Content.vue'
import Loading from '@/components/common/Loading.vue'

export default {
  components: {
    ConsoleHeader,
    ConsoleSidebar,
    ConsoleContent,
    Loading
  },
  data: function () {
    return {
    }
  },
  mounted () {
    this.$eventHub.$on('open-loading', this.$refs.loading.open)
    this.$eventHub.$on('close-loading', this.$refs.loading.close)
  },
  beforeDestroy () {
    this.$eventHub.$off('open-loading')
    this.$eventHub.$off('close-loading')
  },
  methdos: {
  }
}
</script>

<style lang="scss" scoped>
.layout {
  margin: 0px;
  padding: 0px;
  position: relative;
  .header {
    height: 80px;
    margin: 0 auto;
  }
  .sidebar {
    flex: 0 0 180px;
  }
  .body {
    min-height: calc(100vh - 80px);
    flex: 1 1 auto;
  }
  .loading {
    width: 100vw;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/console/Layout.vue